import type NumberUnit from '@exodus/currency';
import { useSelector } from 'react-redux';

import optimisticTotalEnabledBalanceSelector from '../flux/fiat-balances/selectors/optimistic-total-enabled-balance.js';
import selectors from '../flux/selectors.js';

function useTotalBalance(): { value: NumberUnit; loading: boolean } {
  const totalFiatBalance = useSelector(optimisticTotalEnabledBalanceSelector);

  const didLoad = useSelector<unknown, boolean>(selectors.fiatBalances.loaded);

  return {
    value: totalFiatBalance,
    loading: !didLoad,
  };
}

export default useTotalBalance;
